// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__29Wff","content":"styles_content__ztpYS","row":"styles_row__1j3iN","footer":"styles_footer__1QXk-","phraseLength":"styles_phraseLength__ZFYbs"};